import axios from "axios";

export async function getUserIP () {
    return await axios.get('https://ipv4-check-perf.radar.cloudflare.com/api/info');
}